import { css } from '@emotion/react';
import { Link } from 'gatsby';
import React from 'react';

import Config from '../../configs/websiteConfig';
import { useStaticLogoQuery } from '../../graphql/useStaticLogoQuery';

export const StaticLogo = (): JSX.Element => {
  const src = useStaticLogoQuery();

  return (
    <Link className="site-nav-logo" css={SiteNavLogoStyles} to="/">
      {src ? <img src={src} alt={Config.title} /> : Config.title}
    </Link>
  );
};

const SiteNavLogoStyles = css`
  position: relative;
  z-index: 100;
  flex-shrink: 0;
  display: inline-block;
  margin-right: 32px;
  padding: 12px 0;
  color: #fff;
  font-size: 1.7rem;
  line-height: 1.8rem;
  font-weight: bold;
  letter-spacing: -0.5px;
  text-transform: none;

  :hover {
    text-decoration: none;
  }

  img {
    display: block;
    width: auto;
    height: 21px;
  }
`;
